export default function authHeaderFile() {
    return {
        'Content-Type': 'multipart/form-data'
    };
}